export const urlToFile = async (url: string) => {
  return fetch(url).then(async (r) => {
    const u = new URL(url);
    const blob = await r.blob();
    return new File([blob], u.pathname, { type: blob.type });
  });
};
